<template>
  <div class="relative ml-2">
    <!-- Bildirim Butonu -->
    <live-assignment-button
      :count="assignableOrdersCount"
      :has-active-assignments="hasAssignableOrders"
      :crisis-count="crisisOrdersCount"
      @toggle="toggleDropdown"
    />

    <!-- Dropdown Menü -->
    <live-assignment-dropdown
      :is-open="isOpen"
      :orders="liveOrders"
      :loading="loading"
      :last-update="lastUpdate"
      @close="isOpen = false"
      @refresh="fetchData"
      @tab-change="handleTabChange"
      @assign="handleAssignVehicle"
      @bulkAssign="handleBulkAssign"
    />
  </div>
</template>

<script>
import axios from "axios";
import { liveAssignment } from "@/networking/urlmanager";
import moment from "moment";
import { getLocationAll, getProducts, getCustomers } from "@/utils/detailData";
import _ from "lodash";

// Alt bileşenler
import LiveAssignmentButton from './components/LiveAssignmentButton.vue';
import LiveAssignmentDropdown from './components/LiveAssignmentDropdown.vue';

// Servisler
import liveAssignmentService from './services/liveAssignmentService';

export default {
  name: "live-assignment-notification",
  components: {
    LiveAssignmentButton,
    LiveAssignmentDropdown
  },
  
  data() {
    return {
      isOpen: false,
      loading: false,
      liveOrders: [],
      lastUpdate: "-",
      intervalId: null,
      hasActiveAssignments: false,
      
      // Araç önerisi için gerekli alanlar
      vehicleList: [],
      products: [],
      customers: [],
      assignedVehicles: [], // Atanmış araçlar listesi
      currentlyLoadingOrderId: null,
      debouncedCalculateVehicle: _.debounce(this.calculateRecommendedVehicles, 300),
      
      // Kriz durumu için alanlar
      crisisNotifiedOrders: [], // Bildirimi gösterilmiş sipariş ID'leri
    };
  },
  
  computed: {
    totalCount() {
      return this.liveOrders.length;
    },
    // Atanabilecek araç içeren sipariş sayısı
    assignableOrdersCount() {
      return this.liveOrders.filter(order => order.hasAvailableVehicles === true).length;
    },
    // Atanabilecek araç içeren sipariş var mı
    hasAssignableOrders() {
      return this.assignableOrdersCount > 0;
    },
    // Kriz durumundaki sipariş sayısı
    crisisOrdersCount() {
      return this.liveOrders.filter(order => order.hasCrisis === true).length;
    },
    // Kriz durumu var mı?
    hasCrisis() {
      return this.crisisOrdersCount > 0;
    },
    isAuthenticated() {
      return this.$store.state.isAuth;
    }
  },
  
  async mounted() {
    // İlk veri çekimi
    if (this.isAuthenticated) {
      // Token kontrolü
      const token = this.$store.state.userData?.token;
      if (!token) {
        console.error("mounted - Token bulunamadı!");
        // Token yoksa biraz bekleyip tekrar dene
        setTimeout(() => {
          if (this.$store.state.userData?.token) {
            this.initializeData();
          }
        }, 1000);
        return;
      }

      // Ürün ve müşteri verilerini yükle
      this.products = await getProducts(token);
      this.customers = await getCustomers(token);
      this.vehicleList = await getLocationAll(token);
      

      // İlk veriyi yükle ve periyodik güncelleme başlat
      this.initializeData();
    }
    
    // Dropdown dışına tıklandığında kapatma
    document.addEventListener("click", this.handleClickOutside);
  },
  
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    document.removeEventListener("click", this.handleClickOutside);
  },
  
  methods: {
    async initializeData() {
      const token = this.$store.state.userData?.token;
      if (!token) {
        console.error("initializeData - Token hala yok!");
        return;
      }

      // Ürün ve müşteri verilerini yükle
      this.products = await getProducts(token);
      this.customers = await getCustomers(token);
      this.vehicleList = await getLocationAll(token);

      // İlk veri çekimini başlat
      await this.fetchData();

      // PERFORMANS İYİLEŞTİRMESİ: Interval kaldırıldı
      // Artık sadece panel açıldığında veri çekilecek
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        // Panel açıldığında veri çek
        this.fetchData();

        // Panel açıkken 5 dakikada bir güncelle
        if (!this.intervalId) {
          this.intervalId = setInterval(() => {
            if (this.isOpen) { // Panel açıksa güncelle
              this.fetchData(false);
            }
          }, 300000); // 5 dakika = 300000ms
        }
      } else {
        // Panel kapandığında interval'i durdur
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }
    },
    
    handleClickOutside(event) {
      const dropdown = this.$el;
      if (dropdown && !dropdown.contains(event.target)) {
        this.isOpen = false;

        // Panel kapandığında interval'i durdur
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }
    },
    
    async fetchData(showLoading = true) {
      if (!this.isAuthenticated) return;

      // Token kontrolü
      const token = this.$store.state.userData?.token;
      if (!token) {
        console.error("fetchData - Token bulunamadı!");
        return;
      }

      try {
        if (showLoading) {
          this.loading = true;
        }

        // Önce atanmış araçları getir
        this.assignedVehicles = await liveAssignmentService.fetchAssignedVehicles(token);

        // Canlı atama bekleyen siparişleri getir
        const orders = await liveAssignmentService.fetchLiveOrders(token);

        // PERFORMANS İYİLEŞTİRMESİ: Promise.all yerine batch processing
        // Siparişleri 3'erli gruplara böl ve sırayla işle (aynı anda max 3 sipariş)
        const batchSize = 3;
        for (let i = 0; i < orders.length; i += batchSize) {
          const batch = orders.slice(i, i + batchSize);

          await Promise.all(batch.map(async (order) => {
            try {
              // Varsayılan sekmeyi ayarla
              order.activeTab = 'nearby';

              // Araç verilerini hesapla - atanmış araçları gönder
              await this.calculateRecommendedVehicles(order);

              // hasAvailableVehicles bayrağını ayarla
              order.hasAvailableVehicles = (order.nearbyVehicles?.length > 0 || order.recommendedVehicles?.length > 0);

              // Siparişe atanmış araç sayısını bul
              const assignedVehicleCount = this.assignedVehicles.filter(v => v.orderId === order.id).length;

              // Kriz durumu kontrolü
              const crisisStatus = liveAssignmentService.checkCrisisStatus(order, assignedVehicleCount);
              order.crisisStatus = crisisStatus;

              // Kriz durumu varsa bayrağı ayarla
              order.hasCrisis = crisisStatus.isCrisis;

              // ÖNEMLI: Canlı atama modunda kriz uyarısı gösterme
              // Kriz durumu varsa VE ilk karşılaşma ise VE canlı atama modu değilse kullanıcıyı uyar
              if (crisisStatus.isCrisis &&
                  !this.crisisNotifiedOrders.includes(order.id) &&
                  !order.isLiveAssignment) { // Canlı atama kontrolü eklendi
                // Bu sipariş için daha önce bildirim göstermedik, bildirim göster
                this.showCrisisAlert(order, crisisStatus);
                // Bildirilen siparişler listesine ekle
                this.crisisNotifiedOrders.push(order.id);
              }
            } catch (error) {
              console.error("Nearby vehicles error:", error);
              order.nearbyVehicles = [];
              order.recommendedVehicles = [];
              order.hasAvailableVehicles = false;
            }
          }));

          // Her batch'den sonra UI'ı güncelle (kullanıcı ilerlemeyi görsün)
          this.liveOrders = [...orders];
        }

        this.liveOrders = orders;
        this.lastUpdate = moment().format('HH:mm:ss');
      } catch (error) {
        console.error("Live assignments error:", error);
        this.liveOrders = [];
      } finally {
        this.loading = false;
      }
    },
    
    async calculateRecommendedVehicles(order) {
      // Şu anda başka bir sipariş için yükleme yapılıyorsa bekle
      if (this.currentlyLoadingOrderId === order.id) {
        return;
      }

      // Token kontrolü
      const token = this.$store.state.userData?.token;
      if (!token) {
        console.error("Token bulunamadı! Store durumu:", {
          isAuth: this.$store.state.isAuth,
          userData: this.$store.state.userData
        });
        return;
      }

      try {
        this.currentlyLoadingOrderId = order.id;
        order.isLoadingNearby = true;
        order.isLoadingRecommended = true;

        // Servis üzerinden araç önerilerini hesapla - atanmış araçları da gönder
        const { nearbyVehicles, recommendedVehicles } = await liveAssignmentService.calculateRecommendedVehicles(
          order,
          this.vehicleList,
          this.products,
          this.customers,
          token,
          this.assignedVehicles // Atanmış araçları gönder
        );

        // Sonuçları sipariş nesnesine ekle
        order.nearbyVehicles = nearbyVehicles;
        order.recommendedVehicles = recommendedVehicles;
      } catch (error) {
        console.error(`Araç önerisi hesaplanırken hata oluştu (Order ID: ${order.id}):`, error);
        order.nearbyVehicles = [];
        order.recommendedVehicles = [];
      } finally {
        this.currentlyLoadingOrderId = null;
        order.isLoadingNearby = false;
        order.isLoadingRecommended = false;
      }
    },
    
    async handleAssignVehicle(orderId, vehicleId) {
      try {
        this.loading = true;
        
        // İlgili siparişi ve aracı bul
        const order = this.liveOrders.find(o => o.id === orderId);
        const vehicle = [...(order?.nearbyVehicles || []), ...(order?.recommendedVehicles || [])]
          .find(v => v.id === vehicleId);
        
        if (!order || !vehicle) {
          throw new Error("Sipariş veya araç bulunamadı");
        }
        
        // Araç ataması yap
        const result = await liveAssignmentService.assignVehicle(
          orderId,
          vehicle,
          order.orderNo,
          this.$store.state.userData.token
        );
        
        if (result.success) {
          // Başarı mesajı göster
          this.swalBox(
            "success",
            "İşlem Başarılı",
            `${vehicle.plate || vehicle.vehicle} plakalı araç başarıyla atandı.`,
            false,
            "Tamam"
          );

          // Verileri yenile
          this.vehicleList = await getLocationAll(this.$store.state.userData.token);
          this.fetchData();
        } else {
          // Hata mesajı göster
          this.swalBox(
            "error",
            "Hata",
            result.error || "Araç atama işlemi sırasında bir hata oluştu.",
            false,
            "Tamam"
          );
        }
      } catch (error) {
        console.error("Vehicle assignment error:", error);
        
        // Hata mesajı göster
        this.swalBox(
          "error",
          "Hata",
          error.message || "Araç atama işlemi sırasında bir hata oluştu.",
          false,
          "Tamam"
        );
      } finally {
        this.loading = false;
      }
    },
    async handleBulkAssign(orderId,vehicles){
      try {
        this.loading = true;
        
        // İlgili siparişi ve aracı bul
        const order = this.liveOrders.find(o => o.id === orderId);
       
        
        if (!order || !vehicles) {
          throw new Error("Sipariş veya araç bulunamadı");
        }
        
        // Araç ataması yap
        const result = await liveAssignmentService.bulkAssignVehicle(
          orderId,
          vehicles,
          order.orderNo,
          this.$store.state.userData.token
        );
        
        if (result.success) {
          // Başarı mesajı göster
          this.swalBox(
            "success",
            "İşlem Başarılı",
            `${result.data.message}.`,
            false,
            "Tamam"
          );

          // Verileri yenile
          this.vehicleList = await getLocationAll(this.$store.state.userData.token);
          this.fetchData();
        } else {
          // Hata mesajı göster
          this.swalBox(
            "error",
            "Hata",
            result.error || "Araç atama işlemi sırasında bir hata oluştu.",
            false,
            "Tamam"
          );
        }
      } catch (error) {
        console.error("Vehicle assignment error:", error);
        
        // Hata mesajı göster
        this.swalBox(
          "error",
          "Hata",
          error.message || "Araç atama işlemi sırasında bir hata oluştu.",
          false,
          "Tamam"
        );
      } finally {
        this.loading = false;
      }
    },    
    handleTabChange(orderId, tab) {
      const order = this.liveOrders.find(o => o.id === orderId);
      if (order) {
        // Vue'nun reaktivite sisteminin düzgün çalışması için $set kullan
        this.$set(order, 'activeTab', tab);

        // Array'i de güncelleyerek değişikliği zorla
        this.liveOrders = [...this.liveOrders];
      }
    },
    
    // SweetAlert kullanımı için yardımcı metot
    swalBox(icon, title, text, showCancelButton = false, confirmButtonText = "Tamam", cancelButtonText = "İptal") {
      return this.$swal.fire({
        icon,
        title,
        text,
        showCancelButton,
        confirmButtonText,
        cancelButtonText,
        confirmButtonColor: "#ef4444",
        cancelButtonColor: "#9ca3af",
      });
    },
    
    // Kriz durumu uyarısı göster ve araç ekleme ekranına yönlendir
    showCrisisAlert(order, crisisStatus) {
      // Açıklama metni oluştur
      const neededVehicles = crisisStatus.requiredVehicles;
      const assignedVehicles = crisisStatus.assignedVehicles;
      const deficit = crisisStatus.vehicleDeficit;
      
      const message = `"${order.orderNo}" numaralı sipariş için kriz durumu tespit edildi!\n\n` +
                     `İhtiyaç duyulan araç sayısı: ${neededVehicles}\n` +
                     `Mevcut atanmış araç sayısı: ${assignedVehicles}\n` +
                     `Eksik araç sayısı: ${deficit}\n\n` +
                     `Bu durumu düzeltmek için araç ekleme ekranına yönlendirileceksiniz.`;
      
      // Uyarı kutusunu göster
      this.$swal.fire({
        icon: 'warning',
        title: 'Kriz Durumu Uyarısı!',
        html: message.replace(/\n/g, '<br>'),
        showCancelButton: true,
        confirmButtonText: 'Araç Ekleme Ekranına Git',
        cancelButtonText: 'Şimdilik Geç',
        confirmButtonColor: "#ef4444",
        cancelButtonColor: "#9ca3af",
      }).then((result) => {
        if (result.isConfirmed) {
          // Kullanıcı onayladı, araç ekleme ekranına yönlendir
          // Burada Toplu Planlama modülüne yönlendirme yapıyoruz
          
          // Önce rotayı hazırla
          const route = {
            name: 'collectivePlanning',
            params: { orderId: order.id }
          };
          
          // Yönlendirme yap
          this.$router.push(route);
          
          // Açılan sayfada araç ekleme penceresini açmak için event yayınlama (isteye bağlı)
          // Bunun için collectivePlanning modülünde event dinleme mekanizması olmalı
          setTimeout(() => {
            this.$root.$emit('showVehicleAddModal', { orderId: order.id, orderNo: order.orderNo });
          }, 500); // 500ms bekleyerek yönlendirmenin tamamlanmasını sağla
        }
      });
    }
  },
  
  watch: {
    // Kullanıcı giriş yaparsa veya çıkış yaparsa veri yenileme
    isAuthenticated(newVal) {
      if (newVal) {
        // Kullanıcı giriş yaptığında başlangıç verisini yükle
        this.initializeData();
      } else {
        // Kullanıcı çıkış yaptığında interval'i temizle
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }

        this.liveOrders = [];
      }
    }
  }
};
</script>

<style scoped>
/* Animasyon için gerekli ek stiller */
@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.5);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(59, 130, 246, 0);
  }
}

.animate-pulse {
  animation: pulse 1.5s infinite;
}
</style>